// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"hP-z","categoryName":"iP-z","categoryNameSearchHeader":"jP-z","categoryContent":"kP-z","bottomAligned":"lP-z","image":"mP-z","imageNoBackground":"nP-z"};